import { DetectionIcon } from '@/components/ui/icons/DetectionIcon';
import { Column } from '@/components/ui/layout/Column';
import { Row } from '@/components/ui/layout/Row';
import { Text } from '@/components/ui/base/Text';

export const DetectionsPanelSkeleton = () => {
  return (
    <Column gap="md" id="detections-section">
      <Row justify="start">
        <DetectionIcon
          size={24}
          className="fill-neutralText dark:fill-neutralText-dark"
        />
        <Text size="lg" weight="medium">
          Détections
        </Text>{' '}
      </Row>
      <Column>
        <div className="h-10 w-full rounded-lg bg-gray-200 dark:bg-gray-700"></div>
        <div className="h-10 w-full rounded-lg bg-gray-200 dark:bg-gray-700"></div>
        <div className="h-10 w-full rounded-lg bg-gray-200 dark:bg-gray-700"></div>
      </Column>
    </Column>
  );
};
